import { GridStore } from '@roc/feature-app-core';
import { ArrowDownward, ArrowUpward } from '@material-ui/icons';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import { useStatusDashboardStyles } from './statusDashboardStyles';

interface SortableHeaderProps {
  grid: GridStore;
  column: string;
  label: string;
  onSort: () => void;
  // Number columns are right aligned, text columns left aligned
  alignLeft?: boolean;
}

// Column title of a dashboard table; clicking it changes the sort, and the arrow shows the current direction
export const SortableHeader = observer(
  ({ grid, column, label, onSort, alignLeft }: SortableHeaderProps) => {
    const classes = useStatusDashboardStyles();
    const { sortBy, sortDir } = grid.gridData.meta;
    const active = sortBy === column;
    const Arrow = sortDir === 'ASC' ? ArrowUpward : ArrowDownward;

    return (
      <span
        role="button"
        tabIndex={0}
        className={clsx(
          classes.sortableHeader,
          alignLeft ? classes.sortableHeaderLeft : classes.right,
          active && classes.sortableHeaderActive
        )}
        onClick={onSort}
        onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && onSort()}
      >
        {active && !alignLeft && <Arrow className={classes.sortArrow} />}
        {label}
        {active && alignLeft && <Arrow className={classes.sortArrow} />}
      </span>
    );
  }
);
